import React from 'react';
import { TooManySelectionsPlaceholder as TooManySelectionsPlaceholderComponent } from '../../../../components';
import i18n from '../../../../i18n';
import { invalidErrorMessage } from '../../../../actions';

export default function TooManySelectionsPlaceholder({ error }) {
	const [title, description] = invalidErrorMessage(error);
	return <TooManySelectionsPlaceholderComponent title={title} description={description} />;
}
